import { Parameters } from '../../context/parameterContext';
import { MapLogoModalProps } from './mapLogo.types';

// Returns the position of the logo to determine modal position
export const getLogoPosition = (customLogoPosition: Parameters['custom_logo_position'] | undefined, logoRef: React.RefObject<HTMLDivElement>) => {
    const logoRect = logoRef.current?.getBoundingClientRect();

    let position: MapLogoModalProps['position'] = {
        top: 'unset',
        left: 'unset',
        bottom: 'unset',
        right: 'unset'
    };
    if (logoRect) {
        switch (customLogoPosition) {
            case 'top-left': {
                position = {
                    top: `${logoRect.top + logoRect.height + 20}px`,
                    left: `${logoRect.left}px`,
                    bottom: 'unset',
                    right: 'unset'
                };
                break;
            }
            case 'top-right': {
                position = {
                    top: `${logoRect.top + logoRect.height + 20}px`,
                    left: 'unset',
                    bottom: 'unset',
                    right: `${window.innerWidth - logoRect.right}px`
                };
                break;
            }
            case 'bottom-left': {
                position = {
                    top: 'unset',
                    left: `${logoRect.left}px`,
                    bottom: `${window.innerHeight - logoRect.bottom + logoRect.height + 20}px`,
                    right: 'unset'
                };
                break;
            }
            case 'bottom-right': {
                position = {
                    top: 'unset',
                    left: 'unset',
                    bottom: `${window.innerHeight - logoRect.bottom + logoRect.height + 20}px`,
                    right: `${window.innerWidth - logoRect.right}px`
                };
                break;
            }
            default: {
                position = {
                    top: 'unset',
                    left: 'unset',
                    bottom: `${window.innerHeight - logoRect.bottom + logoRect.height + 20}px`,
                    right: `${window.innerWidth - logoRect.right}px`
                };
                break;
            }
        }
    }

    return position;
};
